import { useSearchParams, Link } from "react-router-dom";
import { usePageTitle } from "@/hooks/use-page-title";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { AlertCircle } from "lucide-react";

const REASON_MESSAGES: Record<string, string> = {
  INVALID: "This invitation link is invalid.",
  EXPIRED: "This invitation has expired.",
  ALREADY_ACCEPTED: "This invitation has already been accepted.",
  ALREADY_REJECTED: "This invitation has been rejected.",
  ALREADY_CANCELED: "This invitation has been canceled.",
};

export function InviteErrorPage() {
  usePageTitle("Invitation Error");
  const [searchParams] = useSearchParams();
  const reason = searchParams.get("reason") ?? "INVALID";
  const message = REASON_MESSAGES[reason] ?? REASON_MESSAGES.INVALID;

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <AlertCircle className="h-5 w-5 text-destructive" />
          <CardTitle>Invitation unavailable</CardTitle>
        </div>
        <CardDescription>{message}</CardDescription>
      </CardHeader>
      <CardContent>
        <Link to="/login">
          <Button variant="outline" className="w-full">
            Go to sign in
          </Button>
        </Link>
      </CardContent>
    </Card>
  );
}
